import SurvivorStandingsDivider from '../../components/SurvivorStandingsDivider'
import SurvivorContinuationNotice from '../../components/SurvivorContinuationNotice'
import { playerUrl } from '@severed-links/common.redherrings-constants'
import EliminatorStandingsPickItem from '../Eliminator/EliminatorStandingsPickItem'
import SeasonSelector from '../Football/SeasonSelector'
import NflTeamListItem from '../Football/NflTeamListItem'
import Modal from '@severed-links/common.modal'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as modalStyles from './TerminatorStandingsModal.scss'
import * as styles from '../Eliminator/EliminatorStandings.scss'
import terminatorErrorMessage from './terminatorErrorMessage'
import { useSearchParams, useParams, useNavigate } from 'react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, ListGroup, Image } from 'react-bootstrap'
import { getSeasons, getMainPageData, getStandings } from '@severed-links/common.redherrings-reducers/terminator'
const TerminatorStandings = () => {
  const [smallViewport, setSmallViewport] = useState(() => window.matchMedia('(max-width: 767px)').matches)
  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)')
    const update = () => setSmallViewport(media.matches)
    update()
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])
  const [params] = useSearchParams()
  const route = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { seasons, seasonId } = useSelector(state => state.terminator)
  const setSelected = id => {
    const season = seasons.find(item => item.seasonId === id)
    if (season) navigate(`/terminator/standings/${encodeURIComponent(season.seasonName)}`)
  }
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const value = route.seasonName ? seasons.find(item => item.seasonName === route.seasonName)?.seasonId : params.get('seasonId') || seasonId || ''
  useEffect(() => {
    const season = seasons.find(item => item.seasonId === value)
    if (!route.seasonName && season) navigate(`/terminator/standings/${encodeURIComponent(season.seasonName)}`, { replace: true })
  }, [route.seasonName, seasons, value, navigate])
  const standings = useSelector(state => state.terminator.standings[value])
  const rows = standings?.scoreboardPlayers || []
  const continuingPlayers = rows.filter(player => !player.isEliminated)
  const orderedPlayers = [...continuingPlayers, ...rows.filter(player => player.isEliminated)]
  const viewerId = useSelector(state => state.account?._id)
  const [selectedPlayerId, setSelectedPlayerId] = useState(null)
  const player = rows.find(row => row.playerId === selectedPlayerId)
  const visiblePicks = (player?.picks || []).filter(pick => pick.showPick && (pick.isAfterDeadline || player.playerId === viewerId))
  useEffect(() => { setSelectedPlayerId(null) }, [value, smallViewport])
  useEffect(() => { dispatch(getSeasons()); dispatch(getMainPageData()) }, [dispatch])
  useEffect(() => {
    if (!value) return
    let active = true
    const load = async () => {
      try {
        const action = await dispatch(getStandings(value))
        if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load. Please try again.')
        if (active) setMessage('')
      } catch (error) { if (active) setMessage(terminatorErrorMessage(error)) }
      if (active) setLoading(false)
    }
    setLoading(true)
    load()
    const timer = setInterval(load, 30000)
    return () => { active = false; clearInterval(timer) }
  }, [dispatch, value])
  const season = seasons.find(item => item.seasonId === value)
  return <main className={`${styles.container} ${styles.terminator}`}>
    <div className={styles.heading}>
      <div className={styles.titleContainer}><div><div className={styles.eyebrow}>Terminator</div><h2 className={styles.title}>{season?.seasonName} Standings</h2></div>
        <SeasonSelector seasons={seasons} season={season} onSelect={name => { const next = seasons.find(item => item.seasonName === name); if (next) setSelected(next.seasonId) }} />
      </div>
      <Alert variant='info' className={styles.detail}>{rows.filter(row => !row.isEliminated).length} of {rows.length} players remaining{smallViewport ? ' · Select a player to view picks' : ''}</Alert>
    </div>
    <SurvivorContinuationNotice standings={standings} />
    {message ? <Alert variant='danger'>{message}</Alert> : null}
    <div className={styles.standingsCard}><ListGroup className={styles.list}>
      {loading ? <ListGroup.Item>Loading…</ListGroup.Item> : orderedPlayers.map((row, index) => <React.Fragment key={`terminator-group-${row.playerId}`}>
        {index === continuingPlayers.length && continuingPlayers.length > 0 ? <SurvivorStandingsDivider contest='Terminator' /> : null}
        <ListGroup.Item action={smallViewport} className={styles.item} key={row.playerId} onClick={smallViewport ? () => setSelectedPlayerId(row.playerId) : undefined}>
        <div className={styles.content}><div className={styles.playerSummary}><div className={styles.avatar}><Image src={playerUrl(row.avatarUrl)} alt='' /></div><div className={styles.player}><div className={styles.firstName}>{row.firstName}</div><div className={styles.lastName}>{row.lastName}</div></div></div>
          {smallViewport ? <strong className={`${styles.playerStatus} ${row.isEliminated ? styles.terminated : styles.alive}`}>{row.isEliminated ? 'Terminated' : 'Alive'}</strong> :
            <div className={styles.picks}>
              {(row.picks || []).filter(pick => pick.showPick && pick.isAfterDeadline).map(pick => <EliminatorStandingsPickItem key={pick.weekDisplay} pick={pick} />)}
            </div>}

        </div>
      </ListGroup.Item></React.Fragment>)}
      {!loading && !rows.length ? <ListGroup.Item>No players registered for this season.</ListGroup.Item> : null}
    </ListGroup></div>
    <Modal show={smallViewport && !!player} onClose={() => setSelectedPlayerId(null)} showFooter={false}
      heading={`${player?.firstName || ''} ${player?.lastName || ''}`} bodyClass={modalStyles.body}>
      <ListGroup className={modalStyles.history}>
        {visiblePicks.map(pick => {
          const week = <div className={modalStyles.week}><strong>{pick.week ?? pick.weekDisplay?.replace(/\D/g, '')}</strong><span>{pick.seasonMode === 'Postseason' || pick.weekDisplay?.startsWith('PW') ? 'Playoff' : 'Week'}</span></div>
          const final = pick.isAfterDeadline && pick.isFinalScore
          const result = final ? <span className={pick.isCorrectPick ? modalStyles.correct : modalStyles.incorrect} role='img' aria-label={pick.isCorrectPick ? 'Correct pick' : 'Incorrect pick'}><FontAwesomeIcon name={pick.isCorrectPick ? 'circle-check' : 'xmark'} /></span> : null
          return pick.nflTeam ? <NflTeamListItem key={pick.weekDisplay} {...pick} className={modalStyles.row} left={week} right={result} /> :
            <ListGroup.Item key={pick.weekDisplay} className={`${modalStyles.row} ${modalStyles.noPick}`}>{week}<span className={modalStyles.emptyLabel}>No pick entered.</span>{result}</ListGroup.Item>
        })}
        {!visiblePicks.length ? <ListGroup.Item>No picks located for this player.</ListGroup.Item> : null}
      </ListGroup>
    </Modal>
  </main>
}
export default TerminatorStandings
